<template>
  <div>
    <CContainer class="mb-4">
      <CRow>
        <CCol md="3">
          <CButton class="w-100" color="success" @click="() => { modalVisible.insert = true }">
            <div class="button-text">
              <CIcon name="cil-plus" />
              <span>New</span>
            </div>
          </CButton>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Loader -->
    <CContainer class="d-flex justify-content-center" v-if="isLoad">
      <CSpinner color="primary" size="lg"/>
    </CContainer>
    <CContainer v-else>
      <CRow>
        <CCol 
          :sm="3" 
          v-for="occasion in occasions" 
          :key="occasion.id"
        >
          <CCard>
            <CCardBody>
              <CCardTitle>{{ occasion.occasion_name }}</CCardTitle>
              <p class="card-sub-title">{{ occasion.chinese_name || '-'}}</p>
            </CCardBody>
            <CCardFooter>
              <CButton class="mr-2" color="primary" variant="ghost" @click="handleEdit(occasion)">
                <div class="button-text">
                  <CIcon name="cil-pencil" />
                  <span>Edit</span>
                </div>
              </CButton>
              <CButton color="danger" variant="ghost" @click="() => { 
                modalVisible.delete = true 
                id = occasion.id
              }">
                <div class="button-text">
                  <CIcon name="cil-trash" />
                  <span>Delete</span>
                </div>
              </CButton>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Modal -->
    <CModal
      :show.sync="modalVisible.insert"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <CRow>
        <CCol md="12">
          <CForm class="w-100">
            <div class="mb-3">
              <p></p>
              <CInput
                label="Occasion Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the occasion name. (avoid using '-' or '/')"
                v-model="occasionName"
                :is-valid="occasionNameValidator"
              />
              <CInput
                label="Occasion Chinese Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide a valid occasion name. (avoid using '-' or '/')"
                v-model="occasionChineseName"
                :is-valid="occasionChineseNameValidator"
              />
            </div>
          </CForm>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Insert Occasion</h5>
        <CButtonClose @click="dismissModal" class="text-black"/>
      </template>
      <template #footer>
        <CButton @click="handleInsert" color="primary" :disabled="!isValidatePass">Save</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
    <CModal
      :show.sync="modalVisible.edit"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <CRow>
        <CCol md="12">
          <CForm class="w-100">
            <div class="mb-3">
              <CInput
                label="Occasion Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the occasion name. (avoid using '-' or '/')"
                v-model="occasionName"
                :is-valid="occasionNameValidator"
              />
              <CInput
                label="Occasion Chinese Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide a valid occasion name. (avoid using '-' or '/')"
                v-model="occasionChineseName"
                :is-valid="occasionChineseNameValidator"
              />
            </div>
          </CForm>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Edit Occasion</h5>
        <CButtonClose @click="dismissModal" class="text-black"/>
      </template>
      <template #footer>
        <CButton @click="handleSave" color="primary" :disabled="!isValidatePass">Save</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
    <CModal
      title="Modal title"
      color="danger"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="modalVisible.delete"
    >
      Are you sure you want to delete this item ?
      <template #header>
        <h5 class="modal-title">Delete Occasion</h5>
        <CButtonClose @click="dismissModal" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="handleDelete(id)" color="danger">OK</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { 
  OCCASION_CREATE,
  OCCASION_UPDATE,
  OCCASION_DELETE,
  OCCASION_GET, 
} from '../../../constants/api'

import axios from 'axios'

export default {
  data () {
    return {
      id: '',
      occasionName: '',
      occasionChineseName: '',
      occasions: [],
      validatePass: {
        occasionName: false,
        occasionChineseName: false,
      },
      modalVisible: {
        edit: false,
        insert: false,
        delete: false,
      },
      isLoad: false,
      accessToken: sessionStorage.getItem('access_token') || '',
    }
  },
  
  computed: {
    isValidatePass () {
      return !Object.values(this.validatePass).includes(false)
    }
  },

  beforeMount () {
    this.fetchOccasion()
  },

  methods: {
    fetchOccasion () {
      this.isLoad = true

      axios.get(OCCASION_GET, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(res => {
          this.occasions = res.data.data
          this.isLoad = false
          this.dismissModal()
        })
    }, 

    handleEdit (occasion) {
      const { id, occasion_name, chinese_name } = occasion

      this.id = id
      this.occasionName = occasion_name
      this.occasionChineseName = chinese_name

      this.modalVisible.edit = true
    },

    handleInsert () {
      const payload = {
        name: this.occasionName,
        chinese_name: this.occasionChineseName
      }
      axios.post(OCCASION_CREATE, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchOccasion())
    },

    handleDelete (id) {
      axios.delete(`${OCCASION_DELETE}${id}`, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchOccasion())
    },

    handleSave () {
      const payload = {
        name: this.occasionName,
        chinese_name: this.occasionChineseName
      }
      axios.put(`${OCCASION_UPDATE}${this.id}`, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchOccasion())
    },

    dismissModal () {
      this.id = ''
      this.occasionName = ''
      this.occasionChineseName = ''
      this.modalVisible.edit = false
      this.modalVisible.delete = false
      this.modalVisible.insert = false
    },

    // validator
    occasionNameValidator (val) {
      if (val.length > 0 && !/[-\/]/.test(val)) {
        this.validatePass.occasionName = true
        return true
      } else {
        this.validatePass.occasionName = false
        return false
      }
    },
    occasionChineseNameValidator (val) {
      if (val?.length > 0 && /[-\/]/.test(val)) {
        this.validatePass.occasionChineseName = false
        return false
      }
      this.validatePass.occasionChineseName = true
      return true
    },
  }  
}
</script>

<style scoped>
  .button-text {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .button-text > span {
    margin-left: 6px;
  }
  .card-sub-title {
    font-size: 18px;
  }
</style>